import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Divider } from '@material-ui/core';
import TrackingLoading from './trackingLoading.gif';
import TrackingContainer from './TrackingContainer';
import ProductMessage from '../ProductMessage';
import { getTracking } from '../../../../../redux/actions/TrackingActions';
import ExtraInfo from '../extraInfo/ExtraInfo';
import TrackingEmptyState from './EmptyState';
import { useTrackingStyles } from './styles';
import {
  customizeTrackingMessage,
  defineErrorMessage,
} from '../../../../../helpers/TrackingHelper';

const Tracking = ({ ...props }) => {
  const { dispatch, orderId, handleTracking, mobile, errorTracking } = props;
  const classes = useTrackingStyles();
  const trackingLoading = useSelector((state) => state.trackingReducer.loading);
  const trackingFinishedLoading = useSelector(
    (state) => state.trackingReducer.finishedLoading,
  );
  const reduxDispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(dispatch).length === 0) reduxDispatch(getTracking(orderId));
  }, []);

  return (
    <div className={classes.underProduct}>
      {Object.keys(dispatch).length === 0 && trackingLoading && (
        <div className={classes.loading}>
          <img className={classes.loadingImage} src={TrackingLoading} />
        </div>
      )}
      {Object.keys(dispatch).length === 0 && errorTracking && (
        <>
          <Divider className={classes.divider} />
          <TrackingEmptyState />
        </>
      )}
      {Object.keys(dispatch).length !== 0 &&
        trackingFinishedLoading &&
        !errorTracking && (
          <>
            {!mobile && <Divider className={classes.divider} />}
            <TrackingContainer
              mobile={mobile}
              handleTracking={handleTracking}
              history={dispatch.dispatch_state_history}
              failed={dispatch.failed}
            />
            {Object.keys(dispatch).length !== 0 && !dispatch.failed && (
              <>
                <Divider className={classes.divider} />
                <ExtraInfo dispatch={dispatch} mobile={mobile} />
              </>
            )}
            {Object.keys(dispatch).length !== 0 && dispatch.failed && (
              <ProductMessage
                type="failed"
                fullRounded
                hasInfoBelow={false}
                predefineMessage={
                  customizeTrackingMessage() && defineErrorMessage(dispatch)
                }
              />
            )}
          </>
        )}
    </div>
  );
};

Tracking.propTypes = {
  dispatch: PropTypes.object,
  orderId: PropTypes.number,
  handleTracking: PropTypes.func,
  mobile: PropTypes.bool,
  errorTracking: PropTypes.bool,
};

export default Tracking;
